<template>
<div   class="container-fluid">

<spinner v-bind:spinner='spinner'></spinner>


    <confirm-box v-if="cb.show">
      <template v-slot:header>
      <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body>
        {{cb.msg1}}   
      </template>
        <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-secondary">NO</button>
        <button @click="setConfirmBox(),cb.show=false" type="button" class="btn btn-primary">SI</button>
    </template>    
    </confirm-box>
          
 <div class="card border-info">
  <div  class="card-header bg-info text-black">
    <h4> <strong>LISTA ORDINI INVIATI</strong></h4>
  </div>  

  <div class="card-body">
  <alert-box  class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
  

    
    <div>
        <div  class="scroll table-wrapper-scroll-y my-custom-scrollbar mt-1">
        <table  class="cart table table-hover table-sm mb-0">
        <thead>
        <tr class="table-light">
        <th></th>  
        <th>#</th>  
        <th>MARKET</th>
        <th class="text-nowrap">DATA ORD.</th>
        <th class="text-nowrap">NUM. ORDINE</th>  
        <th>EAN</th>
    
    
  </tr>
  </thead>
  <tbody>
  <tr  class="pointer"  :class="`index-${index}`"  v-for="(item,index) in filteredOrders" :key="index">
      
      <td>
        <!--
        <a @click="deleteItem(index)"><i style='color:blueviolet' data-toggle="tooltip" title="Elimina"  class="fa fa-trash" aria-hidden="true"></i></a>
        -->
      </td>
      <td>{{index+1}}</td> 
      
      <td class="text-nowrap">{{item.mp}}</td>
      <td>{{item.orderDate}}</td>
      <td>{{item.orderId}}</td>
      
      <td>{{item.barcode}}</td>
      
    </tr> 
    </tbody>  

  </table>
</div>
<label class="mt-3" for="cerca"><strong>
  <i  class="fas fa-filter mr-2 mt-3" aria-hidden="true"></i>
    Filtra</strong></label>
<input class="form-control mb-3" type="text" name="query" v-model="filterKey">
</div>
<div>
</div>
</div>
 
   <button @click="getData()" type="button"  class="btn btn-light ">
          <i class="fas fa-sync mr-2"></i>
            AGGIORNA
            
      </button>  
    

   <!-- CARD -->
 
 </div> 


<!-- div container -->
</div>

</template>

<script>

import api                 from '@/api'
import alertBox            from '@/components/common/AlertBox.vue'
import spinner             from '@/components/common/Spinner.vue'
import confirmBox          from '@/components/common/ConfirmBox.vue'
import { mapGetters }      from 'vuex'

//import {setFmtDate1}        from '@/functions'

export default {
    
  mixins: [],
  components: {alertBox,spinner,confirmBox
  
  },
  data () 
  {
    return {
     
      filterKey       : '',
      refresh         : 0,
    
      spinner       : false,
      items         : [],
      msg          : {
       title : '',
       body  : '',
       type  : 0
     },
    
     
    
     cb           : {
       title   : '',
       msg1    : '',
       show    : false
     },
     
     
     
     

      }
  },
   
  computed: 
  {
    ...mapGetters(['storeId','company']) , 
    

    filteredOrders : function () 
      {
        var filterOrders = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterOrders) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterOrders) > -1
          })
        })
      }
        return items
     },
   
  






    total : function() {
   
     
      let  total = {items: 0,total : 0}
      this.cart.forEach(item => {

          total.total  += Number(item.price)
          total.items  += 1
          

      })

      return total
    }
   
    
  },

  mounted : function()
  {
    this.getData()
   
  },
  
  created: function() 
  {
      
  },

  methods: 
  { 

      
    setConfirmBox()
    {
      
      if(this.cb.type =='C')
      {
        this.sendOrderToPrinter()
      }
      else if(this.cb.type =='D')
      {
        
        this.deleteRow()
      }
      else
      {
        //this.resetCart()
      }
    },

    confirmBox()
    { 
        this.msg.title = ""
        this.cb.type = 'C'
        this.cb.title = 'CONFERMI INVIO ORDINE A STAMPANTE ?' 
        this.cb.msg1 = ''

        this.cb.show = true
       
    },  
    
    async getData()
    {
    if(this.company.Id != 26)  
    {
      return
    }
    this.msg.title  = ''
    this.spinner    = true
    const sp        = {'sp' : 'spCaposerioOrdersList'}    
    //const data      = {'barcode' : this.barcode ,'mpId' : this.mp.Id,'companyId':this.company.Id} 
    //const json      = Object.assign(data, sp)
    
    await api.post(sp).then(res => {
      
      if(res.status==200)
        {

          if(res.data.recordsets[0].length==0)
          {
            this.msg.title = "ATTENZIONE "
            this.msg.body  = "Prodotto inesistente."
            this.msg.type  = 1
                        
            return
          }
          
          this.items = res.data.recordsets[0]
                

        }
        else if(res.status==500)
        {
          
          this.msg.title = "ATTENZIONE "
          this.msg.body  = res.data
          this.msg.type  = 1

        } 
        else
        {
          
          this.msg.title = "ATTENZIONE "
          this.msg.body  = res
          this.msg.type  = 1                
          
        } 
    }).catch(err => 
    {
      console.log(err.message)    
    }).finally(() => {
      this.spinner = false
    });
  
    },
    scrollToElement(index) 
    {
      const el = this.$el.getElementsByClassName('index-' + index)[0];
      
      if (el) {
        el.scrollIntoView();
      }
    },
    reset()
    {
      if(this.cart.length>0)
      {
        this.boxType = 'R'
        this.cb.title = 'CONFERMI RESET ORDINE ?'
        this.cb.show = true

      }
    },

   
   async sendOrderToPrinter()
    {
      const data      = this.setOrderData()   
      this.bt_spinner = true
      let arr         = []

      const asyncForEach = async (array, callback) =>
      {
        return new Promise(async(resolve, reject)  =>  {
        for (let index = 0; index < array.length; index++) 
        {
          await callback(array[index]);
        }
        resolve()
        })      
      } 
      //let index = 0
      await asyncForEach(data, async (item) => {         
        return new Promise((resolve, reject)   =>  {
        this.createOrder(item).then(res=>{
          console.log(res)
          resolve()
        }).catch((err) =>{
          
          arr.push(item)
          reject()
          console.log(err)

        })
        //index++
      })
      })
      if(arr.length > 0)
      {
        
        this.msg.title = "ATTENZIONE "
        this.msg.body  = "SI E' VERIFICATO UN ERRORE DURANTE L'INVIO,RIPROVA."
        this.msg.type  = 1
        this.cart = arr
        //console.log(arr)
      }
      else
      {
        this.orderId = ''
        this.mp.Id = 0
        this.cart = []
      }
      this.bt_spinner = false
      //this.refresh++

    },

    
    async createOrder(item)
    { 
      this.msg.title = ''
      
      const url = process.env.VUE_APP_ROOT_API1 + 'sync/caposerio/orders' 
      
      return new Promise(async (resolve, reject) =>  {
      await api.api1(item,url).then(res => {

        if(res.status==200)
          {
            //this.msg.title = "ORDINE INVIATO."
            //this.msg.body  = ""
            //this.msg.type  = 0
          
          //this.cart      = []         
          resolve(res)
          }
          else if(res.status==500)
          {
          
            this.msg.title = "ATTENZIONE "
            this.msg.body  = res.data
            this.msg.type  = 1
            reject(res.data)
          } 
          else
          {
            
            this.msg.title = "ATTENZIONE "
            this.msg.body  = res
            this.msg.type  = 1                             
            reject(res)
          } 
      }).catch(err => 
      {
        console.log('catch',err)    
        reject(err)
      }).finally(() => {
        //this.bt_spinner = false
      });


    }) 

    },
  
    resetCart()
    {
            
      this.cart = []
      
    },
  
    deleteRow()
    {
      this.cart.splice(this.index, 1);      
    },
    deleteItem(index)
    {
      const row     = index + 1
      this.cb.type  = 'D'
      this.cb.title = 'CONFERMI ELIMINAZIONE RIGA : ' + row
      this.index    = index 
      this.cb.show  = true
      
    },

 

 
}
}
</script>
<style scoped>



.table-wrapper-scroll-y {
  display: block;
}

.table-scrollBar
{
  height     :400px;  
  overflow   :scroll;
  overflow-x : hidden;
  
}

.my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }

.pointer:hover
{
  background-color : lightblue(182, 216, 241, 0.972);
  color            : black;
  cursor           : pointer;
}

.cart thead tr:nth-child(1) th
 {
  
    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    /*background   : hwb(210 1% 31%); */
    color        : black;
   
    position   : sticky;
    top        : 0;
    z-index    : 10;

 }
 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 20px;
    background   : whitesmoke;
    color        : black;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

 


h4,p {

  font-size    : 20px;
}

.pointer
{
  cursor       : pointer;
}
.cart th:first-child
{
  border-radius : 0 0 0 8px;
}
.cart th:last-child
{
  border-radius : 0 8px 0 0;  
}

.modal-footer {  
  justify-content: space-between;  
}

.card-header
{
  height: 45px;
}
</style>